/**
 *  유저 상세 > 주문 정보 > 주문 내역 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_ORDER_HISTORY_LIST_FILTER_OPTION_MODEL = {
  /**
   *  주문번호
   */
  orderId: null,
  /**
   *  상품 주문번호
   */
  orderItemId: null,
  /**
   *  브랜드명
   */
  storeName: null,
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  상품 주문 상태
   */
  orderItemStatus: null,
  /**
   *  주문 일시
   */
  orderDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  결제 일시
   */
  paymentDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  상품 준비 일시
   */
  deliveryPrepareDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  발송 처리 일시
   */
  deliveryDispatchDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  배송 완료 일시
   */
  deliveryCompleteDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  상품 ID
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  구매자 연락처
   */
  buyerPhone: null,
  /**
   *  수취인 연락처
   */
  recipientPhone: null,
};

/**
 *  유저 상세 > 주문 정보 > 주문 집계 데이터
 */
export const ACCOUNT_USER_DETAIL_ORDER_SUMMARY_DATA_MODEL = {
  /**
   *  주문 결제 금액
   */
  orderPaymentAmount: null,
  /**
   *  주문 결제 횟수
   */
  orderPaymentCnt: null,
  /**
   *  주문 취소 금액
   */
  orderCancelAmount: null,
  /**
   *  주문 취소 횟수
   */
  orderCancelCnt: null,
  /**
   *  주문 반품 횟수
   */
  orderReturnCnt: null,
  /**
   *  주문 교환 횟수
   */
  orderExchangeCnt: null,
};
